export const menuItems = [
  {
    id: 2,
    label: "Panel ",
    icon: "ri-dashboard-line",

    isMenuCollapsed: false,
    subItems: [
      {
        id: 3,
        label: 'Inicio',
        link: '/'
      },

      {
        id: 8,
        label: "Gestión empresa",
        icon: " ri-file-user-line",

        isMenuCollapsed: false,
        subItems: [
          {
            id: 9,
            label: "Registro de la empresa",
            link: "/forms/listado-empresa"
          },

        ]
      },

      {
        id: 18,
        label: 'Estándares',
        icon: 'ri-checkbox-line',



        isMenuCollapsed: false,
        subItems: [
          {
            id: 9,
            label: "Registro de la empresa",
            link: "/forms/listado-empresa"
          },
          {
            id: 9,
            label: "Registro de la empresa",
            link: "/forms/listado-empresa"
          },
        ]
      },

      {
        id: 19,
        label: 'Reportes',
        icon: ' ri-file-edit-fill',
        link: '/'
      },
      {
        id: 20,
        label: 'Configuraciones',
        icon: 'ri-settings-4-fill',
        link: '/'
      },
      {
        id: 21,
        label: 'Notificaciones',
        icon: ' ri-chat-3-fill',
        link: '/'
      },
      {
        id: 22,
        label: 'Mensajes',
        icon: 'ri-message-line',
        link: '/'
      },
      {
        id: 22,
        label: 'Base de conocimiento',
        icon: ' ri-bookmark-fill',
        link: '/'
      },
    ]
  },
  {
    id: 8,
    label: "Gestión empresa",
    icon: " ri-file-user-line",

    isMenuCollapsed: false,
    subItems: [
      {
        id: 9,
        label: "Registro de la empresa",
        link: "/forms/listado-empresa"
      },
    ]
  },

  /*{
    id: 18,
    label: 'Estandares',
    icon: 'ri-checkbox-line',
    link: '/'
  },*/
  {
    id: 19,
    label: 'Reportes',
    icon: ' ri-file-edit-fill',
    link: '/'
  },
  {
    id: 20,
    label: 'Configuraciones',
    icon: 'ri-settings-4-fill',
    link: '/'
  },
  {
    id: 21,
    label: 'Notificaciones',
    icon: ' ri-chat-3-fill',
    link: '/'
  },
  {
    id: 22,
    label: 'Mensajes',
    icon: 'ri-message-line',
    link: '/'
  },
  {
    id: 22,
    label: 'Base de conocimiento',
    icon: ' ri-bookmark-fill',
    link: '/'
  },
];

